import { Team } from 'dashboard/models/team';
import Action from 'lib/interfaces/Action';

export type TeamActions =
  | Action<TeamActionType.SetTeam, SetTeamPayload>
  | Action<TeamActionType.SetTeamUsers, SetTeamUsersPayload>;

export enum TeamActionType {
  SetTeam = 'team/SET_TEAM',
  SetTeamUsers = 'team/SET_TEAM_USERS',
}

interface SetTeamPayload {
  team: Team;
}

export function setTeam(team: Team): Action<TeamActionType.SetTeam, SetTeamPayload> {
  return {
    payload: {
      team,
    },
    type: TeamActionType.SetTeam,
  };
}

interface SetTeamUsersPayload {
  userIds: string[];
}

export function setTeamUserIds(
  userIds: string[],
): Action<TeamActionType.SetTeamUsers, SetTeamUsersPayload> {
  return {
    payload: {
      userIds,
    },
    type: TeamActionType.SetTeamUsers,
  };
}
